import { Controller } from '@hotwired/stimulus';
import { openModalByUrl } from '../utilities/modal';

export default class extends Controller {
    static targets = ["checkbox"]
    static values = {
        documentUrl: String,
        contractId: String,
        serviceTitle: String,
        serviceCode: String,
        serviceOccurrencesWeekdays: Object,
        serviceOccurrencesTime: Array,
        serviceOccurrencesCount: String,
        serviceActivationDate: String,
        serviceTerminationDate: String,
        servicePrice: String,
        servicePayerName: String,
        servicePayerSurname: String,
        servicePayerEmail: String,
        servicePayerPhone: String,
        servicePayerId: String,
        consentPhotoFilm: Boolean,
        consentReceiveNews: Boolean
    }

    generateContract(event) {
        const checkbox = this.checkboxTarget;

        if (!checkbox.checked) {
            return;
        }

        if (this.documentUrlValue && this.contractIdValue) {
            checkbox.checked = false;

            let url = this.documentUrlValue;

            const formData = this.getFormData()

            let occurrencesString = this.serviceOccurrencesTimeValue.map(occurrence => {
                const dayName = this.serviceOccurrencesWeekdaysValue[occurrence.day];
                return `${dayName} ${occurrence.starts}-${occurrence.ends}`;
            }).join(', ');

            url += (url.includes('?') ? '&' : '?') + `contract_id=${encodeURIComponent(this.contractIdValue)}`;

            url += `&service_title=${encodeURIComponent(this.serviceTitleValue)}`;
            url += `&service_code=${encodeURIComponent(this.serviceCodeValue)}`;
            url += `&service_price=${encodeURIComponent(this.servicePriceValue)}`;
            url += `&service_occurrences_count=${encodeURIComponent(this.serviceOccurrencesCountValue)}`;
            url += `&service_occurrences=${encodeURIComponent(occurrencesString)}`;
            url += `&service_termination_date=${encodeURIComponent(this.serviceTerminationDateValue)}`;
            url += `&service_activation_date=${encodeURIComponent(this.serviceActivationDateValue)}`;
            url += `&service_payer_name=${encodeURIComponent(formData['name'] ?? this.servicePayerNameValue ?? '')}`;
            url += `&service_payer_surname=${encodeURIComponent(formData['surname'] ?? this.servicePayerSurnameValue ?? '')}`;
            url += `&service_payer_email=${encodeURIComponent(formData['email'] ?? this.servicePayerEmailValue ?? '')}`;
            url += `&service_payer_phone=${encodeURIComponent(formData['phone'] ?? this.servicePayerPhoneValue ?? '')}`;
            url += `&service_payer_id=${encodeURIComponent(formData['identification_number'] ?? this.servicePayerIdValue ?? '')}`;
            const getValueOrEmpty = (value) => value || '';

            const visitorName = formData['isSelfVisitor']
                ? getValueOrEmpty(this.servicePayerNameValue) || getValueOrEmpty(formData['name'])
                : getValueOrEmpty(formData['visitorName']);

            const visitorSurname = formData['isSelfVisitor']
                ? getValueOrEmpty(this.servicePayerSurnameValue) || getValueOrEmpty(formData['surname'])
                : getValueOrEmpty(formData['visitorSurname']);

            const visitorId = formData['isSelfVisitor']
                ? getValueOrEmpty(this.servicePayerIdValue) || getValueOrEmpty(formData['identification_number'])
                : getValueOrEmpty(formData['visitorIdNumber']);

            url += `&service_visitor_name=${encodeURIComponent(visitorName)}`;
            url += `&service_visitor_surname=${encodeURIComponent(visitorSurname)}`;
            url += `&service_visitor_id=${encodeURIComponent(visitorId)}`;
            url += `&consent_photo_film=${encodeURIComponent(formData.consentPhotoFilm ?? this.consentPhotoFilmValue)}`;
            url += `&consent_receive_news=${encodeURIComponent(formData.consentReceiveNews ?? this.consentReceiveNewsValue)}`;


            openModalByUrl(url).then(controller => {
                const content = controller.element.querySelector('template').innerHTML;
                const iframe = controller.element.querySelector('iframe');

                //setTimeout needed for Firefox to display content
                setTimeout(() => {
                    iframe.contentWindow.document.body.style.margin = '0';
                    iframe.contentWindow.document.body.style.padding = '0';
                    iframe.contentWindow.document.body.innerHTML = content;
                    iframe.height = iframe.contentWindow.document.body.scrollHeight + 'px';

                    controller.element.querySelector('.accept-contract').addEventListener('click', () => {
                        controller.close();
                        checkbox.checked = true;
                    });
                }, 0);
            });
        }
    }

    getFormData() {
        let groupContainerPresent = true;

        const groupContainer = this.element.closest('.card-content')
        if (!groupContainer) {
            groupContainerPresent = false;
        }

        const form = this.element.closest('form')
        if (!form) {
            return {}
        }

        const formData = new FormData(form)

        const data = {}

        for (let [key, value] of formData.entries()) {
            if (['new_name', 'new_surname', 'new_email', 'new_phone', 'new_identification_number'].includes(key)) {
                data[key.replace('new_', '')] = value
            }

            if (key === 'consents[photo_film]') {
                data.consentPhotoFilm = value === 'on'
            }
            if (key === 'consents[receive_news]') {
                data.consentReceiveNews = value === 'on'
            }
        }

        if (groupContainerPresent) {
            const visitorNameInput = groupContainer.querySelector('input[name$="[visitor_name]"]')
            if (visitorNameInput) {
                data.visitorName = visitorNameInput.value
            }

            const visitorSurnameInput = groupContainer.querySelector('input[name$="[visitor_surname]"]')
            if (visitorSurnameInput) {
                data.visitorSurname = visitorSurnameInput.value
            }

            const visitorIdNumberInput = groupContainer.querySelector('input[name$="[visitor_identification_number]"]')
            if (visitorIdNumberInput) {
                data.visitorIdNumber = visitorIdNumberInput.value
            }

            const selfVisitorCheckbox = groupContainer.querySelector('input[name$="[self_visitor]"]')
            if (selfVisitorCheckbox) {
                data.isSelfVisitor = selfVisitorCheckbox.checked
            }

            const photoFilmConsent = groupContainer.querySelector('input[name="consents[photo_film]"]')
            if (photoFilmConsent) {
                data.consentPhotoFilm = photoFilmConsent.checked
            }

            const receiveNewsConsent = groupContainer.querySelector('input[name="consents[receive_news]"]')
            if (receiveNewsConsent) {
                data.consentReceiveNews = receiveNewsConsent.checked
            }
        }

        return data
    }
}
